module.exports = __webpack_public_path__ + "static/media/IN.e25aa4ec.png";